import { Address } from '@app/domain/model/Address';

function stripStreetSuffix(street: string): string {
    return street
        .replace(/\s+(gatvė|g\.|alėja|al\.|prospektas|pr\.|plentas|pl\.|skveras|sk\.|aikštė|a\.|takas)$/i, '')
        .trim();
}

export function findLithuanianRegistryObjectNoHref(address: Nullable<Address>): string {
    const street = address?.street ? stripStreetSuffix(address.street) : '';

    const params = new URLSearchParams({
        sav: '',
        gat: street,
        nam: address?.houseNumber ?? '',
        but: address?.apartmentNumber ?? '',
        gyv: address?.city ?? '',
    });

    return `https://www.registrucentras.lt/ntr/p/index.php?${params.toString()}`;
}
